<template>
  <div class="submitOrder">
    <!-- 结账 -->
    <md-popup :value="so_pop_show" :mask-closable="false">
      <md-popup-title-bar title="结算" :only-close="true" @cancel="closePop(2)"></md-popup-title-bar>
      <div class="box">
        <div class="box_header">
          <!-- <div>买家名称：</div> -->
          <!-- 选择买家 -->
          <div class="select_buyer">
            <selectBuyer @finish="submitOrderSelect" v-model="so_subData.buyer_name"></selectBuyer>
            <!-- <el-select v-model="so_subData.new_buyer_id" filterable placeholder="请选择" popper-class="submitOrderSelect" :popper-append-to-body="false">
              <el-option
                v-for="item in so_buyer"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select> -->
          </div>
          <div class="shop_buyer_add" @click="ab_popShow = true">新增买家</div>
          <div class="auto_print">
            <span>打印小票</span>
            <md-switch v-model="auto_print" @change="handlerChangeAutoPrint('switch0', auto_print, $event)"></md-switch>
          </div>
          <!-- <div class="select_time">
            <Calendar v-model="data_picker" @change="changeTime"></Calendar>
          </div> -->
        </div>
        <div class="box_content">
          <div class="b_c_left">
            <div class="b_c_left_1">
              <!-- <div>买家名称：{{so_data.buyer_name}}</div> -->
              <div class="receivables">
                应收：
                <span><span style="font-size:0.28rem">￥</span>{{so_subData.receivables}}</span>
              </div>
              <div class="remarks">
                <span>备注：</span>
                <textarea v-model="so_subData.remarks" rows="3" placeholder="请输入备注"></textarea>
              </div>
            </div>
            <div class="pay_type">
              <div v-for="(item,index) in pay_type_list" :key="index" v-show="!(!union_pay && item.value == 5)" @click="handleChangePayType(item.value)" >
                <span>
                  <img :src="item.icon" alt />
                </span>
                <span>{{item.name}}</span>
                <span>
                  <md-radio :name="item.value" v-model="so_subData.pay_type" inline />
                </span>
              </div>
            </div>
          </div>
          <div class="b_c_right">
            <div class="amount_box">
              <!-- 实收 -->
              <div
                class="pop_changeGood_info_inputBox"
                :focus="so_key.active_name == 'payment'"
                @click="selectGoodInput('payment',2)"
              >
                <span>实收</span>
                <input
                  type="text"
                  v-model="so_changeData.payment"
                  :placeholder="so_subData.receivables"
                  readonly
                />
                <span>元</span>
              </div>
              <!-- 赊欠 -->
              <div
                class="pop_changeGood_info_inputBox"
                :focus="so_key.active_name == 'credit'"
                @click="selectGoodInput('credit',2)"
              >
                <span>赊欠</span>
                <input type="text" v-model="so_changeData.credit" readonly />
                <span>元</span>
              </div>
              <!-- 优惠多收 -->
              <div
                class="pop_changeGood_info_inputBox"
                style="border-color:#f1f1f1;user-select:none;"
              >
                <span v-if="so_changeData.discount<=0">优惠</span>
                <span v-else>多收</span>
                <input type="text" v-model="so_changeData.showDiscount" readonly />
                <span>元</span>
              </div>
            </div>
            <div class="amount_keyBoard">
              <KeyBoard
                ref="amountKeyBoard"
                @finish="handleChangeGoodFinish"
                :k_decimal="so_key.decimal"
                v-model="so_key.value"
                @input="handleChangeGoodInput"
              >
                <template slot="diy_btn">
                  <div class="diy_btn">
                    <button style="font-size:0.22rem" @click="creditAll">整单赊欠</button>
                  </div>
                </template>
              </KeyBoard>
            </div>
          </div>
        </div>
      </div>
    </md-popup>
    <!-- 添加买家 -->
    <addBuyer :pop_show="ab_popShow" @cancel="ab_popShow = false" @finish="handleUpdateBuyer" />
  </div>
</template>

<script>
import KeyBoard from "@/components/KeyBoard";
import selectBuyer from "./../buyer/selectBuyer";
import {order_pay ,orderPayPos,orderQueryResult,buyer_list} from "@/api/work/open";

import {timestampToTime} from '@/utils/timestamp'
import Cookies from "@/utils/Cookies";
// import Calendar from "@/components/Calendar"
import addBuyer from "./addBuyer";
export default {
  name: "submitOrder",
  components: {
    KeyBoard,addBuyer, selectBuyer
  },
  data() {
    return {
      auto_print:Cookies.get("auto_print")  ==  -1  ? false : true , // 是否开启自定打印 -1 关闭 1 开启
      union_pay:JSON.parse(Cookies.get("shopInfo")).union_pay || 0 , // 是否支持pos支付
      so_pop_show: this.pop_show,
      so_data: {},
      so_buyer: this.buyerList,
      time:'',
      ab_popShow:false,
      so_main_sn:'',
      so_subData: {
        buyer_id: "1",
        new_buyer_id: "1",
        before_sn:'',
        buyer_name: "临时客户",
        receivables: "",
        discount: "",
        payment: "",
        pay_type: "1",
        goods: "",
        remarks: ""
      },
      so_changeData: {
        receivables: "",
        payment: "",
        credit: 0,
        discount: 0,
        showDiscount: 0
      },
      placeholder: {
        payment: 0
      },
      so_key: {
        active_name: "",
        decimal: 2,
        value: ""
      },
      pos_order_sn:'',
      
      pay_type_list: [
        {
          value: "1",
          name: "现金",
          icon: require("@/assets/img/data/data_cash.png"),
        },
        {
          value: "2",
          name: "支付宝",
          icon: require("@/assets/img/data/data_aliPay.png"),
        },
        {
          value: "3",
          name: "微信",
          icon: require("@/assets/img/data/data_wechat.png"),
        },
        {
          value: "4",
          name: "银行卡",
          icon: require("@/assets/img/data/data_card.png"),
        },
        {
          value: "5",
          name: "POS",
          icon: require("@/assets/img/data/data_POS.png"),
        },
      ],
      order_print:"",
    };
  },
  props: {
    pop_show: {
      type: Boolean,
      default: false
    },
    pop_print: {
      type: String,
      default: ""
    },
    dataJson: {
      type: String,
      default: ""
    },
    buyerList: {
      type: String,
      default: ""
    }
  },
  watch: {
    pop_show: {
      handler(newValue, oldValue) {
        this.so_pop_show = newValue;
      },
      deep: true
    },
    pop_print: {
      handler(newValue, oldValue) {
        this.order_print = newValue;
      },
      deep: true
    },
    dataJson: {
      handler(newValue, oldValue) {
        if(newValue){
          this.so_data = JSON.parse(newValue);
          this.so_main_sn = this.so_data.main_sn
          var remakes_list = this.so_data.remarks;
          var remake = "";
          if (remakes_list && remakes_list.length > 0) {
            for (let i = 0; i < remakes_list.length; i++) {
              const item = remakes_list[i];
              remake += item.user_name + "：" + item.desc + "\n";
            }
          }
          this.so_subData.remarks = remake;
          this.so_subData.buyer_id = this.so_data.buyer_id
          this.so_subData.buyer_name = this.so_data.buyer_name
          this.so_subData.new_buyer_id = this.so_data.buyer_id
          this.so_subData.before_sn = this.so_data.before_sn,
          this.so_subData.goods = JSON.stringify(this.so_data.shop_goods)
          this.so_key.active_name = "payment"
          if (this.so_data.shop_goods) {
            this.computeTotal();
          }
        }
      },
      deep: true
    },
    buyerList: {
      handler(newValue, oldValue) {
        this.so_buyer = JSON.parse(newValue);
      },
      deep: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    // 关闭弹窗
    closePop(type) {
      // type == 1 完成 2 == 取消
      this.$refs.amountKeyBoard.clear()
      this.so_pop_show = false;
      this.order_print = ''
      this.so_subData = {
        buyer_id: "1",
        new_buyer_id: "1",
        buyer_name: "临时客户",
        receivables: "",
        discount: "",
        payment: "",
        pay_type: "1",
        goods: "",
        remarks: ""
      }
      this.so_changeData= {
        receivables: "",
        payment: "",
        credit: 0,
        discount: 0,
        showDiscount: 0
      },
      this.$setLEDText(JSON.parse(this.$Cookies.get("shopInfo")).shop_name)
      this.$emit("cancel",type);
    },

    // 切换买家
    submitOrderSelect(item){
      this.so_subData.new_buyer_id = item.id  
      this.so_subData.buyer_name = item.name
      var order_print = JSON.parse(this.order_print)
      order_print.buyer_name = item.name
      this.order_print = JSON.stringify(order_print)
    },

    // 点击输入框
    selectGoodInput(name, decimal) {
      this.so_key.active_name = name;
      this.so_key.decimal = decimal;
      this.so_key.value = Number(this.so_changeData[this.so_key.active_name]) + "";
      this.$refs.amountKeyBoard.clear();
    },

    // 数据输入中
    handleChangeGoodInput(val) {
      this.so_changeData[this.so_key.active_name] = val;
      var p =
        this.so_changeData.payment === ""
          ? this.so_subData.receivables
          : this.so_changeData.payment;
      var s = Number(Number(p) + Number(this.so_changeData.credit)).toFixed(2);
      var d = Number(Number(s - this.so_changeData.receivables).toFixed(2));
      this.so_changeData.discount = d;
      this.so_changeData.showDiscount = Math.abs(d);
      if ( Number(p) === 0) {
        this.so_subData.pay_type = "0";
      }
      if(Number(p) != 0 && this.so_subData.pay_type == 0){
        this.so_subData.pay_type = "1";
      }
    },

    // 数据修改完成
    handleChangeGoodFinish() {
      var goods = JSON.parse(this.so_subData.goods)
      for (let i = 0; i < goods.length; i++) {
        const im = goods[i];
        if(this.so_subData.new_buyer_id == 1 && im.goods_type == 2 && im.price == 0){
          this.$toast.info(`临时客户不可购买【${im.name}】，请修改！`)
          return false
        }
      }
      this.so_subData.discount = this.so_changeData.discount;
      var p = this.so_changeData.payment === "" ? this.placeholder.payment : this.so_changeData.payment;
      this.so_subData.payment = p;

      let obj = JSON.parse(JSON.stringify(this.so_subData));
      // 如果是整单赊欠 支付方式变成现金
      if (obj.pay_type === 0 || obj.pay_type === "0") {
        obj.pay_type = "1";
      }
      delete obj.receivables_type;
      // 如果是pos支付 先吊起扫码在去请求接口
      if (obj.pay_type == 5) {
        this.pos_subData = JSON.parse(JSON.stringify(obj));
        this.$router.push({
          path: "/public/scan",
          query: {
            message: "",
            reg: "^[0-9]{10,50}$"
          }
        });
      }else{
        this.createOrder(obj).then(res=>{
          // console.log(res)
        })
      }
    },

    // 整单赊欠
    creditAll() {
      this.$refs.amountKeyBoard.clear()
      this.so_changeData.payment = 0;
      this.so_changeData.credit = this.so_changeData.receivables;
      this.so_changeData.discount = 0;
      this.so_changeData.showDiscount = 0;
      this.so_subData.pay_type = 0;
    },

    // 切换支付方式
    handleChangePayType(val){
      this.so_subData.pay_type = val + ''
      
      var p = this.so_changeData.payment === "" ? this.placeholder.payment : this.so_changeData.payment
      if(Number(p) === 0 && Number(this.so_changeData.credit) == Number(this.so_changeData.receivables) && Number(this.so_changeData.discount) === 0){
        this.so_changeData.payment = ''
        this.so_changeData.credit = 0
        this.so_changeData.discount = 0
        this.so_changeData.showDiscount = 0
      }
    },

    // 生成订单
    createOrder(obj){
      return new Promise((resolve, reject)=>{
        order_pay(obj).then(res => {
          if (!this.so_subData.order_sn) {
            if (res.data.order_sn && obj.pay_type == 5) {
              this.pos_order_sn = res.data.order_sn;
              this.pos_subData = JSON.parse(JSON.stringify(obj));
              resolve({type:5,res})
            } else {
              try {
                this.printOrderInfo(res.data.order_sn,res.data.day_num,res.data.pay_date,res.data.trade_url,res.data.order.create_time)
              } catch (error) {
              }
              if (this.so_changeData.credit > 0) {
                if ((this.so_changeData.credit - 0 + obj.discount).toFixed(2) ==obj.receivables) {
                  this.$playaudio("整单赊欠，" + this.so_changeData.credit + "元");
                } else {
                  this.$playaudio( this.pay_type_list[obj.pay_type - 1].name + "收款，" + obj.payment + "元,赊帐，" + this.so_changeData.credit + "元" );
                }
              } else {
                this.$playaudio( this.pay_type_list[obj.pay_type - 1].name + "收款，" + obj.payment + "元" );
              }
              this.$toast.succeed(res.message);
              setTimeout(() => {
                this.closePop(1)
              }, 1000);
              resolve({type:1,res})
            }
          } else {
            this.closePop(1)
            this.$toast.succeed(res.message);
            resolve({type:1,res})
          }
        });
      })
    },

    // pos 收款
    posPay(pay){
      var auth_code = pay;
      this.$toast.loading("支付中...");
      this.createOrder(this.pos_subData).then(({type,res})=>{
        if(type == 5){
          orderPayPos({ auth_code, order_sn: res.data.order_sn,main_sn:this.so_main_sn }).then(res_b => {
            if (res_b.code == 200) {
              if (res_b.data.pay_code == 200) {
                if (this.so_changeData.credit > 0) {
                  this.$playaudio( + this.pay_type_list[this.so_subData.pay_type - 1].name + "收款，" + this.so_subData.payment + "元,赊帐，" + this.so_changeData.credit + "元")
                } else {
                  this.$playaudio( this.pay_type_list[this.so_subData.pay_type - 1].name + "收款，" + this.so_subData.payment + "元")
                }
                try {
                  this.printOrderInfo(res_b.data.order_sn,res_b.data.day_num,res_b.data.pay_date,res_b.data.trade_url,res.data.order.create_time)
                } catch (error) {
                }
                this.$toast.succeed("收银成功!");
                this.closePop(1)
              } else if (res_b.data.pay_code == 203) {
                var t_count = 0;
                var query_t = setInterval(() => {
                  t_count++;
                  if (t_count < 10) {
                    orderQueryResult({ order_sn: this.pos_order_sn,main_sn:this.so_main_sn }).then(res_p => {
                        if (res_p.code == 200) {
                          if (res_p.data.pay_code == 200) {
                            clearInterval(query_t);
                            if (this.so_changeData.credit > 0) {
                              this.$playaudio( + this.pay_type_list[this.so_subData.pay_type - 1].name + "收款，" + this.so_subData.payment + "元,赊帐，" + this.so_changeData.credit + "元")
                            } else {
                              this.$playaudio( this.pay_type_list[this.so_subData.pay_type - 1].name + "收款，" + this.so_subData.payment + "元")
                            }
                            try {
                              this.printOrderInfo(res_p.data.order_sn,res_p.data.day_num,res_p.data.pay_date,res_p.data.trade_url,res.data.order.create_time)
                              } catch (error) {
                            }
                            this.$toast.succeed("收银成功!");
                            this.closePop(1)
                          } else if (res_p.data.pay_code == 201) {
                            // this.closePop(1)
                            this.$toast.failed("支付错误");
                            clearInterval(query_t);
                          } else {
                          }
                        }
                      }
                    );
                  } else {
                    clearInterval(query_t);
                  }
                }, 3000);
              } else {
                // this.closePop(1)
                this.$toast.failed("支付错误");
              }
            }
          }); 
        }
      })
    },

    // 打印订单信息
    printOrderInfo(order_sn,day_num,pay_date,trade_url,date){
      if(!this.auto_print){
        return
      }
      var print_obj = JSON.parse(this.order_print)
      if(date){
        print_obj.date = timestampToTime(date)
      }
      print_obj.order_sn = order_sn
      print_obj.day_num = day_num
      print_obj.trade_url = trade_url
      print_obj.pay_date = pay_date
      print_obj.remarks = this.so_subData.remarks
      print_obj.pay_type = this.so_subData.pay_type
      print_obj.order_amount = this.so_subData.receivables
      print_obj.payment = this.so_subData.payment
      print_obj.discount = this.so_subData.discount
      this.$toast.loading('正在打印中')
      var result= plus.bridge.execSync('sunmiPrint','printOrder',[JSON.stringify(print_obj)])
      if(result.code == 200){
        this.$toast.succeed('打印成功')
      }else{
        this.$toast.failed(result.message)
      }
    },

    // 是否开启自动打印 然后存到cookie
    handlerChangeAutoPrint(name,auto_print){
      Cookies.set("auto_print",auto_print?1 :-1)
    },

    // 计算总价
    computeTotal() {
      var goods = this.so_data.shop_goods;
      var amount = 0;
      for (let i = 0; i < goods.length; i++) {
        const item = goods[i];
        if (item.goods_type == 1) {
          if (item.bale == 1) {
            amount += Math.round(item.price * item.num * 100) / 100;
          } else {
            amount += Math.round(item.price * item.weight * 100) / 100;
          }
        } else if (item.goods_type == 2) {
          amount += Math.round(item.price * item.num * 100) / 100;
        }
      }
      this.so_subData.receivables = Math.round(amount * 100) / 100 || 0;
      this.so_changeData.receivables = Math.round(amount * 100) / 100 || 0;
      this.placeholder.payment = Math.round(amount * 100) / 100 || 0;
      this.$setLEDText( "￥" + this.so_subData.receivables )
    },

    // 更新买家列表
    handleUpdateBuyer(){
      buyer_list().then(res=>{
        if(res.code == 200 ){
          var list = []
          for (const key in res.data.list) {
            if (res.data.list.hasOwnProperty(key)) {
              const item = res.data.list[key];
              list = list.concat(item)
            }
          }
          this.so_buyer = list
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.submitOrder {
  position: relative;
  .md-popup-mask{
    top: 0;
    left: 0;
  }
  .box {
    width: 8.25rem;
    min-height: 6rem;
    background-color: #fff;
    border-radius: 0 0 0.08rem 0.08rem;
    border-top: 0.01rem solid #e1e1e1;
    overflow: hidden;
    padding: 0.2rem;
    padding-top: 0;
    .box_header{
      line-height: 0.48rem;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      margin: 0.1rem 0 0.06rem;
      .select_buyer{
        width: 3.4rem;
      }
      .shop_buyer_add {
        width: 1.28rem;
        height: 0.48rem;
        background-color: #31b158;
        line-height: 0.48rem;
        text-align: center;
        color: #fff;
        font-size: 0.24rem;
        border-radius: 0.04rem;
        margin-left: 0.22rem;
      }
      .auto_print{
        width: 2.96rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 0.24rem;
        span{
          padding-right: 0.1rem;
        }
        .md-switch{
          width: 0.6rem;
          height: 0.36rem;
        }
        .md-switch:before{
            top: 0;
            left: 0;
            width: 0.6rem;
            height: 0.36rem;
            border-radius: 0.18rem;
        }
        .md-switch:after{
            top: 0.03rem;
            left: 0.03rem;
            width: 0.3rem;
            height: 0.3rem;
            background-color: #FFF;
            border-radius: 50%;
        }
        .md-switch.active:after {
            transform: translateX(0.24rem);
        }
      }
    }
    .box_content {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .b_c_left {
        width: 44%;
        height: 5.4rem;
        .b_c_left_1 {
          height: 2.02rem;
          .receivables {
            padding: 0.1rem 0;
            font-size: 0.24rem;
            line-height: 0.38rem;
            display: flex;
            align-items: flex-end;
            &>span {
              font-size: 0.44rem;
              vertical-align: middle;
              color: #f79a07;
              // line-height: 0.6rem;
              // margin-left: -0.16rem;
            }
          }
          .remarks {
            display: flex;
            align-items: flex-start;
            line-height: 0.32rem;
            span{
              padding-top: 0.08rem;
            }
            textarea {
              width: 2.4rem;
              border: 0.01rem solid #e1e1e1;
              padding: 0.08rem;
              border-radius: 0.03rem;
            }
          }
        }
        .pay_type {
          border-top: 0.01rem solid #e1e1e1;
          height: 3.4rem;
          display: flex;
          align-items: center;
          justify-content: space-around;
          flex-direction: column;
          & > div {
            width: 100%;
            height: 0.68rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            span:nth-child(1) {
              width: 0.4rem;
              margin-right: 0.1rem;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 100%;
              }
            }
            span:nth-child(2) {
              flex: 1;
            }
            span:nth-child(3) {
              width: 0.4rem;
            }
          }
        }
      }
      .b_c_right {
        width: 54%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .amount_box {
          height: 2rem;
        }
        .pop_changeGood_info_inputBox {
          width: 100%;
          display: flex;
          align-items: center;
          line-height: 0.48rem;
          border-radius: 0.03rem;
          border: 0.01rem solid #e1e1e1;
          box-sizing: border-box;
          padding: 0 0.1rem;
          margin: 0.1rem 0;
          &[focus] {
            border-color: #31b158;
            input{
              animation: inputFocus 0.8s linear infinite;
              @keyframes inputFocus {
                0% {
                  border-color: #31b158;
                }
                50% {
                  border-color: transparent;
                }
                100% {
                  border-color: #31b158;
                }
              }
            }
          }
          input {
            width: 3.2rem;
            // flex: 1;
            text-align: right;
            padding: 0 0.1rem;
            height: 0.26rem;
            text-align: right;
            padding: 0 0.1rem;
            padding-right: 0.05rem;
            margin-right: 0.05rem;
            border-right: 0.02rem solid transparent;
            border-radius: 0;
          }
        }
      }
    }
  }
}
</style>

<style lang="less">
.submitOrder{
  .el-select{
    input{
      font-size: 0.24rem !important;
      height: 0.48rem !important;
      color: #2c3e50;
      background-color: #e1e1e1;
      &.el-input__inner{
        border: none !important;
      }
    }
    .el-input__icon{
      font-size: 0.24rem !important;
      color: #888 !important;
    }
    .el-input__suffix{
      right: 0.1rem !important;
    }
  }
  .el-select-dropdown{
    max-width: 3.37rem;
    height: 5.2rem;
    .el-select-dropdown__wrap{
      max-height: 5.2rem !important;
    }
    .el-select-dropdown__item{
      font-size: 0.22rem !important;
      line-height: 0.48rem !important;
      height: 0.48rem !important;
    }
  }
  .el-select-dropdown__empty{
    font-size: 0.22rem !important;
  }
}
</style>